
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import CustomerForm from '../../../../NewOrder/Customer/CustomerForm'

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var constants = require('../../../../../utils/domain/constants.js');
var stringUtil = require('../../../../../utils/string/stringUtil');
var validator = require('../../../../../utils/validator/validator');
var saleCalculator = require('../../../../../utils/domain/sales/saleCalculator');
var saleContextUtil = require('../../../utils/saleContextUtil');

class CustomerToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.renderCustomerDialogue = this.renderCustomerDialogue.bind(this);

        this.state = {};
        this.state.showCustomerDialogue = false;
    }

    render()
    {
        let canAddCustomer = saleCommonUtility.canAssociateCustomer(this.props.saleContext);     
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:canAddCustomer ? 1 : 0.5, color: "#787878"}}
                             onClick={(event) =>
                             {
                                event.stopPropagation();

                                if (!canAddCustomer)
                                    return; 

                                this.state.showCustomerDialogue = true;
                                this.setState({});
                             }}>
                            <CustomerIcon size="2.3vw"/>
                        </div>
                        {this.renderCustomerDialogue()}
                </Fragment>)
    }

    renderCustomerDialogue()
    {
        if (!this.state.showCustomerDialogue)
            return null;

        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        let customer = {};
        let selectedAddress = "";
        let deliveryDistance = null;
        let deliveryCharges = null;

        if (saleContext.customerContext != null)
        {
            let customerContext = saleContext.customerContext;
            customer = customerContext.customer;
            
            if (sale.dispatchType == constants.DispatchTypeDelivery)
            {
                let deliveryData = customerContext.deliveryData;

                if (deliveryData != null && !stringUtil.isStringNullOrEmpty(deliveryData.selectedAddress))
                    selectedAddress = deliveryData.selectedAddress;

                if (deliveryData != null && !stringUtil.isStringNullOrEmpty(deliveryData.deliveryDistance))
                    deliveryDistance = deliveryData.deliveryDistance;

                let value = saleCalculator.calculateTotalDeliveryCharges(sale);
                if (value > constants.numericThresholdValue)
                    deliveryCharges = value;
            }
        }
        return <CustomerForm    dispatchType={sale.dispatchType}
                                existingCustomer={customer}
                                selectedAddress={selectedAddress}
                                deliveryDistance={deliveryDistance}
                                deliveryCharges={deliveryCharges}
                                onCancel={()=>
                                {
                                    this.state.showCustomerDialogue = false;
                                    this.setState({});
                                }}
                                onSubmit={(customer, deliveryData) =>
                                {
                                    this.state.showCustomerDialogue = false;
                                    this.setState({});

                                    let dispatchInfo = {};
                                    dispatchInfo.customerName = customer.name;
                                    dispatchInfo.customerPhoneNumber = customer.phoneNumber;
                                    dispatchInfo.customerRating = customer.rating;
                                    dispatchInfo.dispatchType = sale.dispatchType;

                                    if (sale.dispatchType == constants.DispatchTypeDelivery && !stringUtil.isStringNullOrEmpty(deliveryData.selectedAddress))
                                    {
                                        dispatchInfo.deliveryAddress = deliveryData.selectedAddress;
                                        dispatchInfo.distance = deliveryData.deliveryDistance;
                                    }
                                    sale.dispatchInfo = JSON.stringify(dispatchInfo);

                                    if (!stringUtil.isStringNullOrEmpty(deliveryData.deliveryCharges) && 
                                        validator.isNumeric(deliveryData.deliveryCharges) &&
                                        deliveryData.deliveryCharges * 1 > constants.numericThresholdValue)
                                    {

                                        sale.charges = sale.charges.filter(c => c.type != constants.ChargesTypes.VenueDeliveryCharges);

                                        var serviceCharge = {};
                                        serviceCharge.type = constants.ChargesTypes.VenueDeliveryCharges;
                                        serviceCharge.amount = deliveryData.deliveryCharges * 1;
                                        serviceCharge.vat = 0;
                                        serviceCharge.notes = null;
                                        sale.charges.push(serviceCharge);    
                                    }

                                    saleContext.customerContext = {};
                                    saleContext.customerContext.customer = customer;
                                    saleContext.customerContext.deliveryData = deliveryData;
                                    saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                                }}/>

    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(CustomerToolbarButton)

const CustomerIcon = ({size})=>{
    return(
        <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"></path>
</svg>
    )
}